"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _RecommendationSummaryParser = require("../generic/RecommendationSummaryParser");
var _constants = require("../../constants");
var _r10SourceLibrary = require("r10-source-library");
var _BaseComponents = require("../../../components/StyledComponents/BaseComponents");
var _services = require("../../../services");
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const InlineTextContainer = _styledComponents.default.div`
  & p,
  & h2 {
    display: inline-block;
  }
  & p {
    font-size: 12px;
  }
  & h2 {
    font-size: 16px;
  }
`;
const ProductDetailsText = _styledComponents.default.div`
  & p,
  & h2 {
    color: #66686c;
  }
`;
const SummaryRowContainer = _styledComponents.default.div`
  display: 'flex';
  gap: '0';
  flex-direction: 'column';
`;
/**
 * Parser for generating recommendation summary values specific to Chile.
 * Extends the base RecommendationSummaryParser class.
 */
class ChileRecommendationSummaryParser extends _RecommendationSummaryParser.RecommendationSummaryParser {
  constructor(props) {
    super(props);
  }

  /**
   * Calculates the number of columns based on the total term cost and total upfront cost.
   * @returns The number of columns.
   */
  calculateColumns() {
    return 3;
  }

  /**
   * Gets the plan name  for the recommendation summary section.
   * @returns plan name as string.
   */
  getPlanName(product) {
    const planHeader = this.isPlanIdWithDifferentHeader ? _services.locale.localeString('Recommendation.OtherPlanName') : _services.locale.localeString('Recommendation.PlanName');
    const planName = this.showFullPlanName ? product === null || product === void 0 ? void 0 : product.productName : product === null || product === void 0 ? void 0 : product.productName.split('Plan')[1].trim();
    return planHeader + ' ' + planName;
  }
  getDefaultMemoryValue(product) {
    var _product$memory, _product$memory$value, _product$memory2;
    const memory = product === null || product === void 0 ? void 0 : (_product$memory = product.memory) === null || _product$memory === void 0 ? void 0 : (_product$memory$value = _product$memory.value) === null || _product$memory$value === void 0 ? void 0 : _product$memory$value.find(v => v.isDefault);
    return memory ? `${memory.value} ${memory.unitOfMeasure || "GB"}` : product === null || product === void 0 ? void 0 : (_product$memory2 = product.memory) === null || _product$memory2 === void 0 ? void 0 : _product$memory2.valueText;
  }

  /**
   * Gets the component for the recommendation summary section.
   * @returns The recommendation summary component for chile market depending on journeyType or null.
   */
  getRecommendationSummaryComponent(props) {
    const WrapperComponent = this === null || this === void 0 ? void 0 : this.WrapperComponent;
    let hideDiscount, priceValue, transformedProducts;
    if (this.RecommendationSummaryValues) {
      hideDiscount = this.RecommendationSummaryValues.hideDiscount;
      priceValue = this.RecommendationSummaryValues.priceValue;
      transformedProducts = this.RecommendationSummaryValues.transformedProducts;
    }
    const flexDirection = 'row';
    const {
      breakPoints,
      testId,
      isCustomer,
      flexBasis
    } = props;
    const additionalPlanText = _services.locale.localeString(`Recommendation.Additional.additionalText`);
    const additionalPlanHeading = _services.locale.localeString(`Recommendation.plans`);
    if (this.journeyType === _constants.FLAGS.BOTH_FLOW) {
      return /*#__PURE__*/_react.default.createElement(_BaseComponents.BorderWrapper, {
        padding: '20px 24px 20px 24px',
        "data-test-id": `summary-${testId}`
      }, /*#__PURE__*/_react.default.createElement(_BaseComponents.PageWrapper, {
        gap: 10
      }, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
        flexDirection: flexDirection,
        justifyContent: "space-between"
      }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
        size: 1,
        weight: 2,
        dataAttributes: {
          'data-test-id': `order-summary-title-${testId}`
        },
        text: _services.locale.localeString('Recommendation.Summary')
      })), transformedProducts.map((product, index) => {
        var _product$color, _product$color$value$, _product$color$value$2, _product$color$value$3, _locale$localeString;
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: index
        }, /*#__PURE__*/_react.default.createElement(SummaryRowContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
          flexDirection: flexDirection,
          justifyContent: "space-between"
        }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          dataAttributes: {
            'data-test-id': `plan-section-title-${testId}`
          },
          text: _services.locale.localeString(`Recommendation.${product.productType}`),
          noMargin: true
        }), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          text: `${product.productType === _constants.PRODUCT_TYPES.HANDSET ? _services.locale.formatPrice(priceValue) : product.termCostDisplay}`,
          noMargin: true
        }), product.productType !== _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          weight: 3,
          size: 1
        }, "/", _services.locale.localeString('Recommendation.month')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
          flexDirection: flexDirection,
          justifyContent: "space-between",
          gap: "10px"
        }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
          flexBasis: flexBasis,
          flexGrow: 1
        }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
          spacingLevel: {
            bottom: breakPoints.sm ? 3 : 0
          }
        }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          dataAttributes: {
            'data-test-id': `plan-name-${testId}`
          }
        }, product.productType === _constants.PRODUCT_TYPES.HANDSET ? `${product === null || product === void 0 ? void 0 : product.productName},
                                  ${this.getDefaultMemoryValue(product)}, 
                                  ${product === null || product === void 0 ? void 0 : (_product$color = product.color) === null || _product$color === void 0 ? void 0 : (_product$color$value$ = _product$color.value.find(c => c.isDefault)) === null || _product$color$value$ === void 0 ? void 0 : (_product$color$value$2 = _product$color$value$.value) === null || _product$color$value$2 === void 0 ? void 0 : (_product$color$value$3 = _product$color$value$2.split('|')) === null || _product$color$value$3 === void 0 ? void 0 : _product$color$value$3[1]}
                                  ` : this.getPlanName(product))))), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
          flexBasis: flexBasis,
          align: 'right',
          flexGrow: 1
        }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          dataAttributes: {
            'data-test-id': `plan-price-order-summary-${testId}`
          },
          size: 1
        }, product.costSubText)))))), product.productType === _constants.PRODUCT_TYPES.HANDSET && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
          appearance: "secondary"
        }), product.additional && !(isCustomer && this.numberOfPlans === 1) && /*#__PURE__*/_react.default.createElement(SummaryRowContainer, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
          flexDirection: flexDirection,
          justifyContent: "space-between",
          gap: "10px"
        }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          dataAttributes: {
            'data-test-id': `additional-plan-${testId}`
          },
          text: additionalPlanHeading,
          noMargin: true
        }), /*#__PURE__*/_react.default.createElement(InlineTextContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          text: `${_services.locale.formatPrice(product.additional.totalCostAfterDiscount)}`,
          noMargin: true
        }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          weight: 3,
          size: 1
        }, "/", _services.locale.localeString('Recommendation.month')))), /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexContainer, {
          flexDirection: flexDirection,
          justifyContent: "space-between",
          gap: "10px"
        }, /*#__PURE__*/_react.default.createElement(WrapperComponent, null, /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
          flexBasis: flexBasis,
          flexGrow: 1
        }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
          size: 1,
          weight: 3,
          dataAttributes: {
            'data-test-id': `additional-plan-${testId}`
          },
          text: `${additionalPlanText} (${this.totalNumberOfPlans - 1})`,
          noMargin: true
        })), !!this.totalTermCost && /*#__PURE__*/_react.default.createElement(_BaseComponents.FlexItem, {
          flexBasis: flexBasis,
          align: 'right',
          flexGrow: 1
        }, /*#__PURE__*/_react.default.createElement(ProductDetailsText, null, !hideDiscount && product.additional.totalCostAfterDiscount !== product.additional.totalCost && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
          size: 1
        }, (_locale$localeString = _services.locale.localeString('Recommendation.pricePerMonth', {
          amount: product.additional.termDuration,
          price: _services.locale.formatPrice(product.additional.totalCost),
          pluralUnit: _services.locale.localeString('Recommendation.Month')
        })) === null || _locale$localeString === void 0 ? void 0 : _locale$localeString.toLocaleLowerCase())))))));
      }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
        appearance: "secondary"
      })));
    } else {
      return super.getRecommendationSummaryComponent({
        ...props
      });
    }
  }

  /**
   * Returns the product cost subtext based on a given product object.
   * @param product - The SummaryProduct object.
   * @returns The product cost subtext.
   */
  productCostSubText(product) {
    let handsetProductCostSubText = `${_services.locale.localeString('Recommendation.upTo')} ${product.termDuration} ${_services.locale.localeString('Recommendation.installments')}`;
    let planProductCostSubText = _services.locale.localeString('Recommendation.pricePerMonth', {
      amount: product.termDuration,
      unit: _services.locale.localeString('Recommendation.month'),
      price: _services.locale.formatPrice(product.termCost),
      pluralUnit: _services.locale.localeString('Recommendation.Month')
    });
    if (this.journeyType && this.journeyType === _constants.FLAGS.BOTH_FLOW) {
      var _handsetProductCostSu, _planProductCostSubTe;
      handsetProductCostSubText = `${product.termDuration} ${_services.locale.localeString('Recommendation.installments')} ${_services.locale.localeString('Recommendation.from')} 
    ${_services.locale.formatPrice(product.termCost)}/${_services.locale.localeString('Recommendation.month')}`;
      handsetProductCostSubText = (_handsetProductCostSu = handsetProductCostSubText) === null || _handsetProductCostSu === void 0 ? void 0 : _handsetProductCostSu.toLocaleLowerCase();
      planProductCostSubText = (_planProductCostSubTe = planProductCostSubText) === null || _planProductCostSubTe === void 0 ? void 0 : _planProductCostSubTe.toLocaleLowerCase();
    }
    return product.productType === _constants.PRODUCT_TYPES.HANDSET ? handsetProductCostSubText : product.termCostAfterDiscount && product.termCostAfterDiscount !== product.termCost && planProductCostSubText;
  }
}
var _default = ChileRecommendationSummaryParser;
exports.default = _default;